module.exports = __webpack_public_path__ + "/images/agendor-icons.eot";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/agendor-icons.eot?-da6lhh
// module id = 614
// module chunks = 0